import React from 'react';
import { Text } from 'Components/frameworks/text/Text';
import { Title } from 'Components/frameworks/title/Title';
import type { ProductFeatureDetailInformationProps } from './ProductFeatureDetailInformation';
import { ProductFeatureDetailInformation } from './ProductFeatureDetailInformation';
type Props = {
  className?: string;
  items: Array<ProductFeatureDetailInformationProps>;
  notes?: string;
  title?: string;
};
export const ProductFeatureDetailInformations = ({
  className,
  items = [],
  notes,
  title = '',
}: Props) => {
  if (!items.length) {
    return null;
  }

  return (
    <section className={className}>
      <Title className="mb-20" hLevel={3} theme="title-brand-n4">
        {title}
      </Title>
      <ul className="m-0 list-none p-0 sm:columns-2">
        {items.map((item, idx) => {
          return item && item.description ? (
            <li
              className={`list-disc break-inside-avoid-column my-10${idx === 0 ? 'mt-0' : ''}`}
              key={item.description}
            >
              <ProductFeatureDetailInformation {...item} />
            </li>
          ) : null;
        })}
      </ul>
      {!!notes && <Text className="mt-10 text-darkGrey" text={notes} theme="text-sans-n2" />}
    </section>
  );
};
